import { useTranslation } from 'react-i18next';
import { baseLang } from '../i18n/index.js';

export function Datenschutz() {
  const { t, i18n } = useTranslation();
  const showNotice = baseLang(i18n.language) !== 'de';
  return (
    <div className="card card-wide">
      {showNotice && <div className="alert alert-info">{t('legalNotice.deAuthoritative')}</div>}
      <h2 className="card-title">Datenschutzhinweise</h2>
      <p className="card-subtitle">
        Stand: 22.10.2026 · Diese Hinweise gelten für die Websites <strong>www.gql-partner.de</strong> und
        <strong> onboarding.gql-partner.de</strong>. Für www.gql-partner.de gehen die dortigen
        Datenschutzhinweise vor; für die Bearbeitung des Mandats gelten unsere Datenschutzhinweise für Mandanten.
      </p>

      <h3 className="legal-h">1. Name und Kontaktdaten des Verantwortlichen</h3>
      <p>
        Verantwortlicher im Sinne der DSGVO ist:<br /><br />
        <strong>GQL Gussone Quecke Legal Partnerschaft von Rechtsanwälten mbB</strong> (im Folgenden: GQL)<br />
        Strausberger Platz 19<br />
        10243 Berlin<br />
        Deutschland<br /><br />
        E-Mail: <a href="mailto:datenschutz@gql-partner.de">datenschutz@gql-partner.de</a><br />
        Vertretungsberechtigte Partner: RA Dr. Peter Gussone, RA Moritz Quecke
      </p>

      <h3 className="legal-h">2. Erhebung und Speicherung personenbezogener Daten</h3>

      <h4 className="legal-h4">a) Beim Besuch unserer Websites (Server-Logfiles)</h4>
      <p>
        Beim Aufrufen unserer Websites werden durch den auf Ihrem Endgerät zum Einsatz kommenden Browser
        automatisch Informationen an den Server gesendet und temporär in einem sog. Logfile gespeichert:
      </p>
      <ul>
        <li>IP-Adresse des anfragenden Rechners</li>
        <li>Datum und Uhrzeit des Zugriffs</li>
        <li>Name und URL der abgerufenen Datei</li>
        <li>Website, von der aus der Zugriff erfolgt (Referrer-URL)</li>
        <li>verwendeter Browser und ggf. das Betriebssystem Ihres Rechners sowie der Name Ihres Access-Providers</li>
      </ul>
      <p>
        Zwecke: Gewährleistung eines reibungslosen Verbindungsaufbaus, Auswertung der Systemsicherheit und
        -stabilität, administrative Zwecke. <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. f DSGVO
        (berechtigtes Interesse). <strong>Speicherdauer:</strong> 7 Tage rollierend, danach automatische
        Löschung. In keinem Fall verwenden wir die Daten zur Bildung von Nutzerprofilen.
      </p>

      <h4 className="legal-h4">b) Bei Nutzung unseres Kontaktformulars (auf www.gql-partner.de)</h4>
      <p>
        Wenn Sie über das Kontaktformular auf gql-partner.de Kontakt aufnehmen, verarbeiten wir die von Ihnen
        eingegebenen Daten (mindestens E-Mail-Adresse, weitere Angaben freiwillig) zum Zweck der Bearbeitung
        Ihrer Anfrage. <strong>Rechtsgrundlage:</strong> Art. 6 Abs. 1 lit. a DSGVO (Einwilligung) sowie
        Art. 6 Abs. 1 lit. b DSGVO (Anbahnung Mandatsverhältnis). Die Daten werden nach Erledigung
        Ihrer Anfrage automatisch gelöscht, soweit keine gesetzlichen Aufbewahrungspflichten entgegenstehen.
      </p>

      <h4 className="legal-h4">c) Bei Nutzung des Mandanten-Onboardings (auf onboarding.gql-partner.de)</h4>
      <p>
        Über das Onboarding-Portal können Sie sich als potentielle/r Mandant/in registrieren und Ihren
        Sachverhalt strukturiert übermitteln. Wir verarbeiten dazu:
      </p>
      <ul>
        <li><strong>Stammdaten:</strong> Vorname, Nachname, Geburtsdatum, E-Mail-Adresse</li>
        <li><strong>Sachverhaltsdaten:</strong> Ihre Schilderung, Rechtsgebiet, Angaben zur Gegenseite (sofern angegeben), Vollmachts-Einverständnis</li>
        <li><strong>Hochgeladene Unterlagen:</strong> Von Ihnen aktiv hochgeladene Dokumente (z. B. Ausweis, Vollmacht, Korrespondenz, Beweismittel)</li>
        <li><strong>Auth- und Session-Daten:</strong> Verifikations-Token (gehasht), Login-Token (gehasht), Session-ID</li>
      </ul>
      <p>
        <strong>Zwecke:</strong> Anbahnung und Durchführung eines anwaltlichen Mandats; Identifikationspflichten
        nach Geldwäschegesetz; Bot-Abwehr.<br />
        <strong>Rechtsgrundlagen:</strong> Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen),
        Art. 6 Abs. 1 lit. f DSGVO (Missbrauchsabwehr, Audit-Log), Art. 6 Abs. 1 lit. c DSGVO (gesetzliche
        Pflichten, insb. § 11 GwG).
      </p>

      <h4 className="legal-h4">d) Bei Buchung eines Online-Termins (Microsoft Bookings)</h4>
      <p>
        Für die Vereinbarung eines 30-Minuten-Erstgesprächs nutzen wir Microsoft Bookings. Sie geben
        dort Name, E-Mail und einen freien Wunschtermin ein. Daraus wird ein Microsoft-Teams-Meeting
        erzeugt. Verantwortlich für die Buchungsseite und das Meeting ist GQL; Auftragsverarbeiter ist
        die Microsoft Corporation (siehe Ziffer 4).
      </p>

      <h3 className="legal-h">3. Weitergabe von Daten</h3>
      <p>
        Eine Übermittlung Ihrer Daten an Dritte findet nur statt, wenn (a) Sie eine ausdrückliche
        Einwilligung erteilt haben (Art. 6 Abs. 1 lit. a DSGVO), (b) die Weitergabe zur Geltendmachung,
        Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist (Art. 6 Abs. 1 lit. f DSGVO),
        (c) eine gesetzliche Verpflichtung dazu besteht (Art. 6 Abs. 1 lit. c DSGVO) oder (d) dies
        nach Art. 6 Abs. 1 lit. b DSGVO für die Abwicklung des Mandatsverhältnisses mit Ihnen
        erforderlich ist.
      </p>
      <p>
        Innerhalb der Kanzlei erhalten ausschließlich die für die Bearbeitung Ihres Anliegens zuständigen
        Rechtsanwälte und ihnen zuarbeitendes Personal Zugriff auf Ihre Daten. Sämtliche
        Beteiligten unterliegen der anwaltlichen Verschwiegenheitspflicht (§ 43a Abs. 2 BRAO).
      </p>

      <h3 className="legal-h">4. Auftragsverarbeiter (Art. 28 DSGVO)</h3>
      <p>Wir bedienen uns folgender Auftragsverarbeiter:</p>
      <ul>
        <li>
          <strong>Mittwald CM Service GmbH &amp; Co. KG</strong>, Königsberger Straße 4-6, 32339 Espelkamp,
          Deutschland — Hosting von www.gql-partner.de. Rechenzentrum in Deutschland.
        </li>
        <li>
          <strong>Hetzner Online GmbH</strong>, Industriestraße 25, 91710 Gunzenhausen, Deutschland —
          Hosting von onboarding.gql-partner.de (Rechenzentrumsstandort Helsinki/Finnland, EU/EWR).
        </li>
        <li>
          <strong>Microsoft Ireland Operations Ltd.</strong>, One Microsoft Place, South County Business
          Park, Leopardstown, Dublin 18, D18 P521, Irland — Microsoft 365 (E-Mail-Versand über Microsoft Graph
          via quecke@gql-partner.de), Microsoft Bookings (Online-Terminvereinbarung) und Microsoft Teams
          (Online-Besprechung des Erstgesprächs). EU-Standardvertragsklauseln zusätzlich vereinbart.
        </li>
        <li>
          <strong>Cloudflare, Inc.</strong>, 101 Townsend St, San Francisco, CA 94107, USA — Cloudflare
          Turnstile (Bot-Schutz auf onboarding.gql-partner.de); Verarbeitung von IP-Adresse und minimalen
          technischen Fingerabdruck-Daten ausschließlich zur Bot-Erkennung. EU-Standardvertragsklauseln
          vereinbart.
        </li>
      </ul>
      <p>
        Mit jedem Auftragsverarbeiter haben wir einen Vertrag zur Auftragsverarbeitung nach Art. 28 DSGVO
        abgeschlossen. Eine Übermittlung in Drittstaaten außerhalb EU/EWR findet darüber hinaus nicht
        statt; soweit Microsoft- oder Cloudflare-Backbone-Infrastruktur in den USA berührt sein kann,
        gelten die jeweiligen EU-Standardvertragsklauseln und zusätzliche technische und organisatorische
        Maßnahmen.
      </p>

      <h3 className="legal-h">5. Übermittlung in unser Akten- und Mandantenverwaltungssystem</h3>
      <p>
        Sobald Sie das Onboarding-Formular abschicken oder als Mandant/in aufgenommen werden, übertragen
        wir die zugehörigen Daten in unser internes Akten- und Mandantenverwaltungssystem (JurNodes),
        das in Deutschland gehostet wird. Dort unterliegen Ihre Daten der anwaltlichen
        Verschwiegenheitspflicht (§ 43a Abs. 2 BRAO, § 203 StGB).
      </p>

      <h3 className="legal-h">6. Cookies</h3>
      <p>
        <strong>Auf onboarding.gql-partner.de</strong> setzen wir ausschließlich ein technisch notwendiges
        Session-Cookie (Name: <code>sid</code>) ein, das Ihre Anmeldung während der Browser-Sitzung aufrecht
        erhält. Keine Tracking-, Analyse- oder Werbe-Cookies. Eine Einwilligung nach § 25 TTDSG ist daher
        nicht erforderlich.
      </p>
      <p>
        <strong>Auf www.gql-partner.de</strong> setzen wir nur technisch notwendige Cookies ein, die für
        den Betrieb der Website unverzichtbar sind. Sollten zu einem späteren Zeitpunkt Reichweitenmessungs-
        oder Marketing-Cookies hinzukommen, werden wir Sie vor deren Einsatz um ausdrückliche Einwilligung
        ersuchen.
      </p>

      <h3 className="legal-h">7. Speicherdauer im Überblick</h3>
      <ul>
        <li><strong>Server-Logfiles:</strong> 7 Tage rollierend.</li>
        <li><strong>Onboarding-Entwürfe (nicht abgeschickt):</strong> bis zu 90 Tage nach letztem Zugriff, danach automatische Löschung.</li>
        <li><strong>Hochgeladene Dateien im Onboarding-Server:</strong> nach Submit Übergabe an JurNodes; anschließend Löschung auf dem Onboarding-Server.</li>
        <li><strong>Daten im Akten­system (JurNodes):</strong> gemäß gesetzlicher Aufbewahrungsfristen — insb. § 50 BRAO (mindestens 6 Jahre nach Ablauf des Kalenderjahres, in dem das Mandat geendet hat), §§ 147 AO, 257 HGB für rechnungsrelevante Vorgänge.</li>
        <li><strong>Bei Ablehnung der Mandatsannahme:</strong> auf Wunsch sofortige Löschung; sonst gemäß gesetzlicher Fristen.</li>
      </ul>

      <h3 className="legal-h">8. Betroffenenrechte</h3>
      <p>Sie haben jederzeit das Recht:</p>
      <ul>
        <li>gemäß Art. 15 DSGVO Auskunft über Ihre von uns verarbeiteten personenbezogenen Daten zu verlangen;</li>
        <li>gemäß Art. 16 DSGVO unverzüglich die Berichtigung unrichtiger oder Vervollständigung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen;</li>
        <li>gemäß Art. 17 DSGVO die Löschung Ihrer bei uns gespeicherten personenbezogenen Daten zu verlangen, soweit nicht die Verarbeitung zur Erfüllung einer rechtlichen Verpflichtung oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist;</li>
        <li>gemäß Art. 18 DSGVO die Einschränkung der Verarbeitung Ihrer personenbezogenen Daten zu verlangen;</li>
        <li>gemäß Art. 20 DSGVO Ihre uns bereitgestellten personenbezogenen Daten in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen zu verlangen;</li>
        <li>gemäß Art. 7 Abs. 3 DSGVO Ihre einmal erteilte Einwilligung jederzeit gegenüber uns zu widerrufen, mit Wirkung für die Zukunft;</li>
        <li>gemäß Art. 77 DSGVO sich bei einer Aufsichtsbehörde zu beschweren (siehe Ziffer 10).</li>
      </ul>

      <h3 className="legal-h">9. Widerspruchsrecht</h3>
      <p>
        Sofern Ihre personenbezogenen Daten auf Grundlage berechtigter Interessen gemäß Art. 6 Abs. 1 lit. f
        DSGVO verarbeitet werden, haben Sie das Recht, gemäß Art. 21 DSGVO Widerspruch gegen die Verarbeitung
        einzulegen, soweit dafür Gründe vorliegen, die sich aus Ihrer besonderen Situation ergeben. Möchten
        Sie von Ihrem Widerspruchsrecht Gebrauch machen, genügt eine E-Mail an
        {' '}<a href="mailto:datenschutz@gql-partner.de">datenschutz@gql-partner.de</a>.
      </p>

      <h3 className="legal-h">10. Beschwerderecht bei der Aufsichtsbehörde</h3>
      <p>
        In der Regel können Sie sich an die Aufsichtsbehörde Ihres üblichen Aufenthaltsortes oder
        Arbeitsplatzes oder unseres Kanzleisitzes wenden. Für unseren Sitz Berlin ist zuständig:<br /><br />
        <strong>Berliner Beauftragte für Datenschutz und Informationsfreiheit</strong><br />
        Alt-Moabit 59-61<br />
        10555 Berlin<br />
        <a href="https://www.datenschutz-berlin.de" target="_blank" rel="noreferrer">www.datenschutz-berlin.de</a>
      </p>

      <h3 className="legal-h">11. Datensicherheit</h3>
      <p>
        Wir verwenden auf beiden Websites ausschließlich TLS-verschlüsselte Verbindungen (HTTPS) mit aktuellen
        Cipher-Suites. Sensible Stammdaten (insb. Geburtsdatum) werden auf onboarding.gql-partner.de
        zusätzlich spaltenbezogen in der Datenbank verschlüsselt (pgcrypto). Server stehen in der
        Europäischen Union. Im Übrigen bedienen wir uns geeigneter technischer und organisatorischer
        Sicherheitsmaßnahmen, die fortlaufend dem Stand der Technik angepasst werden.
      </p>

      <h3 className="legal-h">12. Aktualität und Änderung dieser Hinweise</h3>
      <p>
        Diese Datenschutzhinweise sind aktuell gültig und haben den Stand <strong>22.10.2026</strong>.
        Durch Weiterentwicklung unserer Websites und Angebote oder aufgrund geänderter gesetzlicher
        Vorgaben kann es notwendig werden, diese Hinweise zu ändern. Die jeweils aktuelle Fassung
        ist abrufbar unter <a href="https://onboarding.gql-partner.de/datenschutz">https://onboarding.gql-partner.de/datenschutz</a>.
      </p>
    </div>
  );
}
